module.exports = __webpack_public_path__ + "img/Image 2.c8e80775.png";